import React from 'react'
import PageList from '../../../components/PageListAPI'
import { getPaymentsListAPI, delPaymentsByIdAPI } from '../../../api/tariff.api'
import { useHistory, useLocation } from 'react-router-dom'

export default function PaymentsList() {
  const location = useLocation()
  const history = useHistory()
  return <div className='App-paper'>
    <PageList
      name='tariff-list'
      title='Оплата'
      columns={[
        { id: 'dateCreate', name: 'Дата создания', type: 'date', formatDate:'LLL' },
        { id: 'datePayment', name: 'Дата оплаты', type: 'date', formatDate:'DD.MM.YYYY' },
        { id: 'accountName', name: 'Аккаунт' },
        { id: 'planName', name: 'Тариф' },
        { id: 'price', name: 'Сумма' },
        { id: 'user', name: 'Добавил' },
      ]}
      createItem={true}
      deleteItem={true}
      headerInit={{
        sortBy: 'dateCreate',
        sortDirection: 'desc',
      }}
      click={false}
      loadAPI={{
        request: getPaymentsListAPI,
      }}
      deleteAPI={delPaymentsByIdAPI}
      location={location}
      history={history}
    />
  </div>
}